import { usePaymentTypeEnum } from '@services/operation'
import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'

type Props = SelectProps

export const PaymentTypeSelect = (props: Props) => {
  const { t } = useTranslation()

  const { data } = usePaymentTypeEnum()

  return (
    <Select {...props}>
      {data.map(x => (
        <Select.Option key={x.id} value={x.id}>
          {x.label}
        </Select.Option>
      ))}
    </Select>
  )
}

export default PaymentTypeSelect
